import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var Alignment;

(function (Alignment) {
  Alignment[Alignment["flex-start"] = 0] = "flex-start";
  Alignment[Alignment["center"] = 1] = "center";
})(Alignment || (Alignment = {}));

var BaseRadioBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-basis: 100%;\n  padding: ", "px;\n  align-items: ", ";\n  gap: ", "px;\n  cursor: ", ";\n  ", ";\n\n  background: ", ";\n  border: solid 1px ", ";\n  ", ";\n  border-radius: 5px;\n  ", ";\n  -webkit-transition: background-color 400ms linear;\n  -ms-transition: background-color 400ms linear;\n  transition: background-color 400ms linear;\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-basis: 100%;\n  padding: ", "px;\n  align-items: ", ";\n  gap: ", "px;\n  cursor: ", ";\n  ", ";\n\n  background: ", ";\n  border: solid 1px ", ";\n  ", ";\n  border-radius: 5px;\n  ", ";\n  -webkit-transition: background-color 400ms linear;\n  -ms-transition: background-color 400ms linear;\n  transition: background-color 400ms linear;\n"])), function (props) {
  return props.flexDirection ? props.flexDirection : 'row';
}, function (props) {
  return props.padding;
}, function (props) {
  return props.align;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  return props.isDisabled ? 'default' : 'pointer';
}, function (props) {
  return props.isDisabled && 'opacity: 0.4';
}, function (props) {
  var _a;

  return props.checked ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.blueLight : props.background;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.medium;
}, function (props) {
  return props.checked && props.border && "border: 1px solid ".concat(props.border && props.border);
}, function (props) {
  return props.boxShadow && props.checked && 'box-shadow: 0px 2px 5px rgba(7, 52, 99, 0.15)';
});
var templateObject_1;
export { Alignment, BaseRadioBox };